// Compute the whole-year age from an ISO date-of-birth string. Returns null
// for missing / unparseable / future dates. Used by the Register dialog and
// anywhere the frontend needs the current age (backend also refreshes patient
// docs on GET so most call sites just read patient.age directly).
export function computeAgeYears(dob) {
  if (!dob) return null;
  const m = String(dob).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const y = parseInt(m[1], 10), mo = parseInt(m[2], 10), d = parseInt(m[3], 10);
  if (!y || !mo || !d) return null;
  const dobDate = new Date(y, mo - 1, d);
  const today = new Date();
  if (dobDate > today) return null;
  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDiff = today.getMonth() - dobDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) age--;
  return age >= 0 ? age : null;
}
